"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiOpenIdConnectSecurityScheme = exports.OpenApiOAuth2SecurityScheme = exports.OpenApiHttpSecurityScheme = exports.OpenApiApiKeySecurityScheme = exports.OpenApiSecurityScheme = void 0;
const utils_1 = require("@dev-stream/utils");
const utils_2 = require("@dev-stream/utils");
const oauth_flows_1 = require("./oauth-flows");
class OpenApiSecurityScheme extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiSecurityScheme;
    }
    GetDefaultValue() {
        return {
            type: "apiKey",
        };
    }
    static isOpenApiSecurityScheme(obj) {
        return (obj instanceof OpenApiSecurityScheme ||
            (0, utils_2.hasUnionKeysStrict)(obj, ["type"]));
    }
}
exports.OpenApiSecurityScheme = OpenApiSecurityScheme;
class OpenApiApiKeySecurityScheme extends OpenApiSecurityScheme {
    GetDefaultValue() {
        return { in: "header", name: "", type: "apiKey" };
    }
    static isOpenApiApiKeySecurityScheme(obj) {
        return (obj instanceof OpenApiApiKeySecurityScheme ||
            (OpenApiSecurityScheme.isOpenApiSecurityScheme(obj) &&
                (0, utils_2.hasUnionKeysStrict)(obj, [
                    "name",
                    "in",
                ]) &&
                obj.type == "apiKey"));
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiApiKeySecurityScheme;
    }
}
exports.OpenApiApiKeySecurityScheme = OpenApiApiKeySecurityScheme;
class OpenApiHttpSecurityScheme extends OpenApiSecurityScheme {
    GetDefaultValue() {
        return { type: "http", scheme: "" };
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiHttpSecurityScheme;
    }
    static isOpenApiHttpSecurityScheme(obj) {
        return (obj instanceof OpenApiHttpSecurityScheme ||
            (OpenApiSecurityScheme.isOpenApiSecurityScheme(obj) &&
                (0, utils_2.hasUnionKeysStrict)(obj, [
                    "scheme",
                ]) &&
                obj.type == "http"));
    }
}
exports.OpenApiHttpSecurityScheme = OpenApiHttpSecurityScheme;
class OpenApiOAuth2SecurityScheme extends OpenApiSecurityScheme {
    GetDefaultValue() {
        return { type: "oauth2", flows: new oauth_flows_1.OpenApiOAuthFlows() };
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOAuth2SecurityScheme;
    }
    static isOpenApiOAuth2SecurityScheme(obj) {
        return (obj instanceof OpenApiOAuth2SecurityScheme ||
            (OpenApiSecurityScheme.isOpenApiSecurityScheme(obj) &&
                (0, utils_2.hasUnionKeysStrict)(obj, [
                    "flows",
                ]) &&
                obj.type == "oauth2"));
    }
}
__decorate([
    (0, utils_1.Property)(() => oauth_flows_1.OpenApiOAuthFlows)
], OpenApiOAuth2SecurityScheme.prototype, "flows", void 0);
exports.OpenApiOAuth2SecurityScheme = OpenApiOAuth2SecurityScheme;
class OpenApiOpenIdConnectSecurityScheme extends OpenApiSecurityScheme {
    GetDefaultValue() {
        return { type: "openIdConnect", openIdConnectUrl: "" };
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOpenIdConnectSecurityScheme;
    }
    static isOpenApiOpenIdConnectSecurityScheme(obj) {
        return (obj instanceof OpenApiOpenIdConnectSecurityScheme ||
            (OpenApiSecurityScheme.isOpenApiSecurityScheme(obj) &&
                (0, utils_2.hasUnionKeysStrict)(obj, [
                    "openIdConnectUrl",
                ]) &&
                obj.type == "openIdConnect"));
    }
}
exports.OpenApiOpenIdConnectSecurityScheme = OpenApiOpenIdConnectSecurityScheme;
